// Factions: the sides in large-scale PvP (realm vs realm, or town alliances). A character belongs to one.
// Kept generic on purpose: a faction can be a realm, an alliance of home towns, or a single town.
// Names are placeholders; rename freely, but keep ids stable once characters exist.
export interface Faction { id: number; name: string; color: string }

export const FACTIONS: Faction[] = [
  { id: 1, name: 'Sunvale', color: '#f9c776' },
  { id: 2, name: 'Moonmere', color: '#8fc7ec' },
  { id: 3, name: 'Thornwood', color: '#8fbf5a' },
];

export const factionById = (id: number): Faction | undefined => FACTIONS.find(f => f.id === id);
